module.exports = __webpack_public_path__ + "img/course-item-c.c691cd73.png";